import 'slick-carousel/slick/slick.scss';
import 'slick-carousel';

/**
 *
 * Hero Slider
 * Slick Slider: https://github.com/kenwheeler/slick
 * Used on Startpage
 *
 */

class HeroContainer {
    constructor(elem) {
        this.elem = elem;
        this.theme = this.elem.dataset.theme;
    }
    init() {
        let settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            prevArrow: `<button class="slide-arrow slide-arrow--prev" type="button"><div class="arrow"></div></button>`,
            nextArrow: `<button class="slide-arrow slide-arrow--next" type="button"><div class="arrow"></div></button>`,
        };

        if ( this.theme === 'hero-boxed') {
            settings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4300,
                arrows: false,
                dots: true,
                fade: true,
                cssEase: 'linear',
                customPaging : function(slider, i) {
                    const dotCount = i + 1
                    return '<div class="slick-dot--custom"><span>' + dotCount + '</span><svg class="progress-ring" height="40" width="40">\n' +
                    '<circle class="progress-ring__circle" r="16" cx="20" cy="20"></circle>\n' +
                    '</svg></div>';
                },
            };
        }

        $( '.hero-container' ).slick( settings );
    }
}

export default HeroContainer;
